import type { LinksFilterInputType } from "@/types/graphql/partner.generated";

/**
 * Значения фильтра из querystring в аргумент `links(filter:)`. Единая сборка
 * для списка и кнопки отчёта.
 */
export function buildLinksFilter(
  filter: Record<string, unknown>
): LinksFilterInputType {
  return { search: filter.search as string | undefined };
}
